import { OverTimeCatDTO } from "./overtime-category.dto";
import { Injectable } from "@nestjs/common";
import {OverTimeCategory}  from '../overtime-category.entity';

@Injectable()
export class OverTimeCatAdapter{
    
    public converDtoToEntity(overTimeCatDTO: OverTimeCatDTO, isUpdate: boolean = false): OverTimeCategory{
        const overTimeCatEntity = new OverTimeCategory();
        overTimeCatEntity.overTimeCategoryId = overTimeCatDTO.overTimeCategoryId;
        overTimeCatEntity.overTimeCategoryName = overTimeCatDTO.overTimeCategoryName;
        overTimeCatEntity.isActive = overTimeCatDTO.isActive == undefined ? true : overTimeCatDTO.isActive;
        if(isUpdate){
            overTimeCatEntity.updatedUser = overTimeCatDTO.updatedUser;
        }else {
            overTimeCatEntity.isActive = true;
            overTimeCatEntity.createdUser = overTimeCatDTO.createdUser;
        }
        return overTimeCatEntity;
    }

    public convertEntityToDto(overTimeCatObject: OverTimeCategory): OverTimeCatDTO{
        const overTimeCatDTO = new OverTimeCatDTO;
        overTimeCatDTO.overTimeCategoryId = overTimeCatObject.overTimeCategoryId;
        overTimeCatDTO.overTimeCategoryName = overTimeCatObject.overTimeCategoryName;
        overTimeCatDTO.isActive = overTimeCatObject.isActive;
        overTimeCatDTO.createdAt = overTimeCatObject.createdAt;
        overTimeCatDTO.updatedAt = overTimeCatObject.updatedAt;
        overTimeCatDTO.updatedUser = overTimeCatObject.updatedUser;
        overTimeCatDTO.createdUser = overTimeCatObject.createdUser;
        overTimeCatDTO.versionFlag = overTimeCatObject.versionFlag;
        return overTimeCatDTO;
    }
    
}